import styles from './Header.module.css'
import { Link } from "react-router-dom";
import logo from '../assets/img/logo.svg'

export default function Header() {
    return (
        <header className={styles.main_header}>
            <Link to="/"><img src={logo} alt='Лого' className={styles.logo}></img></Link>
        </header>
    );
}
